import { FC } from 'react'
import * as yup from 'yup'

const validationSchema = yup.object({
    title: yup
        .string()
        .matches(/[a-zA-Zа-яА-Я0-9,.;:?!№()-]/)
        .required('Название обязательное'),
})

import { Button, Stack } from '@mui/material'
import Typography from '@mui/material/Typography'
import { ModalDialogWrapper } from '../../components/ModalDialogWrapper'

type Props = {
    open: boolean
    handleClose: VoidFunction
    handleSubmit: VoidFunction
}

export const ProjectProtectedOffDialog: FC<Props> = ({ handleClose, handleSubmit, open }) => {
    return (
        <ModalDialogWrapper
            footerActions={
                <Stack direction="row" gap={1} width="100%" justifyContent="flex-end">
                    <Button
                        sx={{ fontSize: '13px' }}
                        fullWidth={true}
                        variant="outlined"
                        onClick={handleClose}>
                        Вернуться назад
                    </Button>
                    <Button fullWidth={true} variant="contained" onClick={handleSubmit}>
                        Отключить
                    </Button>
                </Stack>
            }
            open={open}
            handleClose={handleClose}
            colorSubmitButton="primary"
            title="Отключить защиту?">
            <Typography variant="body2" mb={1}>
                Если вы отключите защищённый режим, для обработки данных проекта (запросы, записи,
                встречи) будут использоваться сервисы нейросетей, включая те, что расположены за
                пределами РФ.
            </Typography>
            <Typography variant="body2" mb={1}>
                Обратите внимание, что это действие необратимо - в дальнейшем вы не сможете снова
                включить защищённый режим для этого проекта
            </Typography>
        </ModalDialogWrapper>
    )
}
